import type { ProductFiltersModel } from '../model';
import { ensureArray } from '~/utils/ensureArray';

type SimpleValue = string | number | undefined | null;

export function cleanProductFilters(
  values: Record<string, SimpleValue | SimpleValue[]>
): ProductFiltersModel {
  return Object.fromEntries(
    Object.entries(values)
      .filter(
        ([_, value]) =>
          !(value == null || (Array.isArray(value) && value.length === 0))
      )
      .map(([key, values]) => [
        key,
        ensureArray(values).map((value) => String(value))
      ])
  );
}
